import DataConst from 'consts/DataConst';

export default {
  name: DataConst.MODELS.PRODUCT,
  primaryKey: 'id',
  properties: {
    id: 'int',
    barcode: 'string?',
    name: 'string',
    sellPrice: 'double',
    sellPrice1: { type: 'double', default: 0 },
    sellPrice2: { type: 'double', default: 0 },
    quantity: { type: 'double', default: 0 },
    buyPrice: { type: 'double', default: 0 },
    sold: { type: 'double', default: 0 },
    icon: 'string?',
    note: 'string?',
    category: 'Category?',
    unit: 'Unit?',
    createdAt: 'date',
    updatedAt: 'date?'
  }
};
